/** Preferences Approvals — shown for consumer-mail external users only (#1456 PO). */
export const APPROVALS_PUBLIC_DOMAIN_NOTE =
  'Feature is disabled for public domains. Register with a private domain to enable this feature';
